import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M14.6667 11.3333L12 8.66663V10.6666H9.33337V12H12V14L14.6667 11.3333Z" fill="black"/>
<path d="M8.00004 12H4.00004L1.33337 14.6667V2.66671C1.33337 1.93337 1.93337 1.33337 2.66671 1.33337H13.3334C14.0667 1.33337 14.6667 1.93337 14.6667 2.66671V7.33337H13.3334V2.66671H2.66671V10.6667H8.00004V12Z" fill="black"/>
</svg>
;
